import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks/useUserContext'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

const RiskManagementApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.RISK_MANAGEMENT}
        scope='risk_management'
        envKey={apps[AppId.RISK_MANAGEMENT].runtimeEnvKey}
        entryPath='./RiskManagementApp'
        url={process.env.REACT_APP_RISK_MANAGEMENT_APP_DEV_PATH}
        appName={apps[AppId.RISK_MANAGEMENT].name}
        appProps={{
          user,
          initialPath: apps[AppId.RISK_MANAGEMENT].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  () => true
)

export { RiskManagementApp }
